import {
  Alert,
  Checkbox,
  Col,
  Form,
  Image,
  Input,
  message,
  Radio,
  Row,
  Select,
  Skeleton,
  Steps,
} from "antd";
import * as AUTH_SERVICES from "api/services/auth/auth.services";
import { registerUserDto } from "api/services/auth/dto/login-user.dto";
import Container from "components/container";
import CryptoJS from 'crypto-js';
import React, { Dispatch, FC, useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { registerStudentWithEmailAndPassword } from "store/auth/authSlice";
import * as TEACHER_SERVICES from "../../../api/services/teacher/teacher.services";
//!COMPONENTS
import H1 from "components/libs/title";

//!IMAGES
import arrowDown from "../../../assets/images/app/arrow_bottom_down.svg";
import arrowUp from "../../../assets/images/app/arrow_top_up.svg";
import Avatar from "../../../assets/images/app/avatars/default_avatar.svg";
import Check from "../../../assets/images/app/checkAlert.svg";
import Close from "../../../assets/images/app/closeDeleteIcon.svg";
import EditButton from "../../../assets/images/app/edit_avatar_button.svg";

//!STYLES
import s from "./assets/register.module.css";
import style from "./assets/stepTwo.module.css";

//!ROUTES
import { fetchSchoolsByLevel } from "api/services/courses/courses.services";
import { findLevelsById } from "api/services/levels/levels.services";
import { getSystemList } from "api/services/studentQuizz/studentQuizz.services";
import { StatusCode } from "common/enums";
import AppButton from "components/libs/button";
import H2 from "components/libs/subtitle";
import PhoneOTPModal from "components/OTP/phoneVerification";
import * as appRoutes from "config/routes.config";
import PhoneInput from "react-phone-input-2";
import fr from "react-phone-input-2/lang/fr.json";
import TimeZoneList from "screens/teacher/components/TimeZoneList";
import { useGetAllLevelsQuery } from "store/services/app/levels.services";
import { useCheckEmailMutation } from "store/services/app/user.services";
import AnimatedPage from "utils/animatedPage";

import EmailOTPModal from "components/OTP/emailVerification";
import { appAuth, RecaptchaVerifier } from "../../../config/firebase.config";

import AvatarModal from "components/avatarsModal";
import { fetchSignInMethodsForEmail } from "firebase/auth";

const { Step } = Steps;
const { Search } = Input;

declare global {
  interface Window {
    recaptchaVerifier: any;
  }
}

const RegisterStudent = () => {
  //!HOOK
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const { isAppInMaintenance } = useSelector((state) => state.auth);
  const { data: levelsData, isLoading, isError } = useGetAllLevelsQuery();
  const levels = useSelector((state) => state.levels);
  const [form] = Form.useForm();
  const location = useLocation();
  const [checkEmail, { isSuccess, data }] =
    useCheckEmailMutation();
  const isLoggedIn = auth.isLoggedIn;

  //!STATE
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [firstStepData, setFirstStepData] = useState<any>({});
  const [tempLevelSelected, setTempLevelSelected] = useState<any>(null);
  const [countriesList, setCountries] = useState<any>([]);
  const [schoolList, setSchoolList] = useState<string[]>([]);
  const [dataList, setDataList] = useState<any>([]);
  const [educationSystemList, setEducationSystem] = useState<string[]>([]);

  const [country, setCountry] = useState<string>();
  const [system, setSystem] = useState<string>();
  const [studentEmail, setStudentEmail] = useState<string>();
  const [studentLevelId, setStudentLevelId] = useState<string>();

  const [checkingPrimary, setCheckPrimary] = useState<boolean>(false);
  const [checkingCollege, setCheckCollege] = useState<boolean>(false);
  const [checkingLycee, setCheckLycee] = useState<boolean>(false);
  const [checkingPrepa, setCheckPrepa] = useState<boolean>(false);

  const [loadingSystems, setLoadingSystems] = useState<boolean>(false);
  const [loadingSchools, setLoadingSchools] = useState<boolean>(false);

  const [images, setImages] = React.useState<any>([]);
  const maxNumber = 1;
  const studentIcon = "/assets/avatars/student.svg";

  const [isLoadingCode, setIsLoadingCode] = useState<boolean>(false);

  const [sponsorCode, setSponsorCode] = useState<any>("");
  const [validSponsorCode, setValidSponsorCode] = useState<boolean>(false);
  const [sponsorCodeChecked, setSponsorCodeChecked] = useState<boolean>(false);
  const [errorEmail, setErrorEmail] = useState<boolean>(false);

  const [openSections, setOpenSections] = useState<{ [key: string]: boolean }>({});
  const toggleSection = (levelGroup: string) => {
    setOpenSections((prev) => ({ ...prev, [levelGroup]: !prev[levelGroup] }));
  };

  const [userEmail, setUserEmail] = useState<string>("");
  const [userPhoneNumber, setUserPhoneNumber] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const [searchText, setSearchText] = useState("");

  const [openPhoneVerification, setOpenPhoneVerification] = useState<boolean>(false);
  const [openEmailVerification, setOpenEmailVerification] = useState<boolean>(false);
  const [confirmationResult, setConfirmationResult] = useState<any>(null);

  const [selectedSchool, setSelectedSchool] = useState<string>();
  const [studentSchool, setStudentSchool] = useState<string>();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedAvatar, setSelectedAvatar] = useState<string>("");
  const defaultAvatar = "https://res.cloudinary.com/dcfvrpurc/image/upload/v1761906754/avatars/default_avatar_fsd1kc.svg";

  ///const [isUnderOrganism, setIsUnderOrganism] = useState<boolean>(false);

  const filteredSchools = useMemo(() => {
    const matches = schoolList.filter((item: string) =>
      item.toLowerCase().includes(searchText.toLowerCase())
    );

    if (searchText && matches.length === 0) {
      return ["Autre établissement"];
    }

    return matches;
  }, [searchText, schoolList]);

  //!CONSTANTS
  const validateMessages = {
    required: t("auth.error.required"),
    types: {
      email: t("auth.error.emailInvalid"),
    },
  };

  const handlePhoneChange = (value: string) => {
    setUserPhoneNumber("+" + value);
  };

  const handleVerify = (otp: string) => {
    // Call Firebase confirm() or your backend verification
    verifyOtp(otp);
  };

  // Setup invisible reCAPTCHA
  const setUpRecaptcha = () => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        "recaptcha-container",
        { size: "invisible" },
        appAuth
      );
    }
  };

  // Step 1: Send OTP
  const sendOtp = async () => {
    try {
      const response = await AUTH_SERVICES.requestPhoneOTP(userPhoneNumber);
      if (response?.statusCode === StatusCode.CREATED) {
        setOpenPhoneVerification(true);
        setLoading(false);
        message.success(`Nous avons envoyé un code par SMS au ${userPhoneNumber}`);
      }
    } catch (error: any) {
      setLoading(false);
    }
  };

  // Step 2: Verify OTP
  const verifyOtp = async (otp: string) => {
    try {
      setLoading(true);
      const response = await AUTH_SERVICES.verifyPhoneOTP(userPhoneNumber, otp);
      if (response?.statusCode === StatusCode.CREATED) {
        message.success("Code vérifié avec succès !");
        setOpenPhoneVerification(false);
        await AUTH_SERVICES.requestOTP(userEmail, "student");
        setOpenEmailVerification(true);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      message.error("Code invalide !");
      setLoading(false);
    }
  };

  //!FUNCTIONS
  const registerUser = async (values: registerUserDto) => {
    setLoading(true);
    if (currentStep === 1) {
      setFirstStepData(values);
      window.scrollTo(0, 0);

      try {
        console.error("Firebase checking email...");
        const methods = await fetchSignInMethodsForEmail(appAuth, values.email);

        if (methods.length > 0) {
          // Email already has an account
          setCurrentStep(1);
          setErrorEmail(true);
          setLoading(false);
          return;
        } else {
          // Email is available
          console.error("Mongo checking email...");
          checkEmail({ email: values.email }).then(async (value: any) => {
            const valueData = value?.data;
            if (valueData?.data?.found) {
              setCurrentStep(1);
              setErrorEmail(true);
              setLoading(false);
            }
            else {
              setUserEmail(values.email);
              //sendOtp();
              await AUTH_SERVICES.requestOTP(values.email, "student");
              setOpenEmailVerification(true);
              setLoading(false);
            }
          });
        }

      } catch (error) {
        console.error("Error checking email:", error);
        return false;
      }
    }
    else {
      setLoading(true);
      const firstStep = {
        ...firstStepData,
        profile: selectedAvatar || defaultAvatar,
        phone: userPhoneNumber?.split("+")[1],
        emailVerified: true,
      };
      values = { ...firstStep, levelId: tempLevelSelected?._id, ...values };
      dispatch(registerStudentWithEmailAndPassword(values));
    }
  };

  const getStaticLists = useCallback(
    async (type: string, dataList: any, state: Dispatch<any>) => {
      const response = await TEACHER_SERVICES.getDataList(type);
      if (response?.statusCode === StatusCode.OK) {
        state(response?.data);
      }
    },
    [dataList]
  );

  const handleCountryChange = (value: string) => {
    setCountry(value);
  };

  const handleSystemChange = (value: string) => {
    setSystem(value);
  };

  const getSchoolsLists = useCallback(
    async () => {
      try {
        setLoadingSchools(true);
        if (country && system && studentLevelId) {
          const response = await fetchSchoolsByLevel(country, system, studentLevelId);
          if (response?.statusCode === StatusCode.OK) {
            const namesArray = response.data.map((item: { name: any; }) => item);
            setSchoolList(namesArray);
            ///setSchoolList(response?.data?.data || []);
          }
        }
      }
      catch (error) {
        ///message.error("Une erreur non connue s'est produite.");
      }
      finally {
        setLoadingSchools(false);
      }
    },
    [country, system, studentLevelId]
  );

  const getSystemLists = useCallback(
    async () => {
      try {
        setLoadingSystems(true);
        if (country !== undefined) {
          const response = await getSystemList(country);
          if (response?.statusCode === StatusCode.OK) {
            const systemArray = response.data.map((item: { name: any; }) => item);
            setEducationSystem(systemArray);
          }
        }
      }
      catch (error) {
        ///message.error("Une erreur non connue s'est produite.");
      }
      finally {
        setLoadingSystems(false);
      }
    },
    [country]
  );

  const getLevelById = useCallback(
    async (idLevel: any) => {
      setStudentLevelId(idLevel);
      try {
        if (idLevel) {
          const response = await findLevelsById(idLevel);
          if (response.statusCode === StatusCode.OK) {
            setTempLevelSelected(response?.data);
          }
        }
      } catch (error) {
        // message.error("Une erreur non connue s'est produite.");
      }
    },
    [tempLevelSelected]
  );

  const onChange = (imageList: any, addUpdateIndex: any) => {
    setImages(imageList);
  };

  const allLevels = levelsData?.data;

  const checkSponsorCode = async (code: string) => {
    if (!code) return;

    try {
      setIsLoadingCode(true);
      const response = await TEACHER_SERVICES.checkSponsorCode(code);
      if (response?.status === "OK") {
        setSponsorCodeChecked(true);
        setValidSponsorCode(true);
      }
      else {
        setSponsorCodeChecked(true);
        setValidSponsorCode(false);
        message.error("Code parrainage incorrect !");
      }
    } catch (error) {
      setSponsorCodeChecked(true);
      setValidSponsorCode(false);
    } finally {
      setIsLoadingCode(false);
    }
  };

  const handleOtpSubmit = async (otp: string) => {
    try {
      setLoading(true);
      const response = await AUTH_SERVICES.validateOTP(userEmail, otp);
      if (response?.data?.success === true) {
        message.success({
          content: "Email vérifié avec succès.",
        });
        setOpenEmailVerification(false);
        setCurrentStep(2);
      }
      else {
        message.warning({
          content: "Ce code est invalide !, consulte tes mails et entre le code reçu.",
        });
      }
    } catch (error: any) {
      let content = "";
      for (
        let index = 0;
        index < error?.response?.data?.message?.length;
        index++
      ) {
        content = error?.response?.data?.message[index] + ", " + content;
      }
      message.error({
        content: content,
      });
    }
    finally {
      setLoading(false);
    }
  };

  //!EFFECTS
  useEffect(() => {
    getStaticLists('pays', countriesList, setCountries);
    if (auth.isLoggedIn) navigate(appRoutes.ONBOARDING);
  }, [auth.isLoggedIn, navigate]);

  useEffect(() => {
    getSchoolsLists();
  }, [country, system, studentLevelId]);

  useEffect(() => {
    getSystemLists();
  }, [country]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams !== undefined) {
      const token = searchParams.get('token');
      if (token !== null) {
        const decodedToken = token!.replace(/\s/g, '+');
        // Decrypt
        const secretKey = process.env.REACT_APP_SECRET_KEY!;
        const decryptedBytes = CryptoJS.AES.decrypt(decodedToken, secretKey!);
        const decodedEmail = decryptedBytes.toString(CryptoJS.enc.Utf8);
        setStudentEmail(decodedEmail);
        form.setFieldsValue({ email: decodedEmail });
        /* setIsUnderOrganism(true); */
      }
      /* else {
        setIsUnderOrganism(false);
      } */
    }
  }, [location.search, form]);

  useEffect(() => {
    setSearchText("");
  }, [schoolList]);

  useEffect(() => {
    if (isAppInMaintenance) {
      navigate(appRoutes.MAINTENANCE);
    };
  }, [isAppInMaintenance]);

  /* useEffect(() => {
    const affiliateToken = localStorage.getItem("affiliateToken");
    if (affiliateToken) {
      setIsUnderOrganism(true);
    }
    else {
      setIsUnderOrganism(false);
    }
  }, []); */

  return (
    <>
      <AnimatedPage>
        <div className={s.register}>
          <Form
            form={form}
            validateTrigger={["onFinish"]}
            validateMessages={validateMessages}
            initialValues={{ acceptedMessagesAndNotifications: true, acceptedTermsAndConditions: true }}
            name="registerTeacher"
            autoComplete="off"
            onFinish={registerUser}
          >
            {currentStep === 1 && (
              <div>
                <div className={style.register__teacher}>
                  <Container>
                    <H1>Crée ton compte</H1>

                    <h3 className={s.__title_choice__avatar}>Choisis ton avatar</h3>
                    <Form.Item name="avatar" hidden initialValue="null"></Form.Item>

                    <Row justify="center" style={{ marginBottom: "20px" }}>
                      <Form.Item name="profile" style={{ margin: 0 }}>
                        <div className={s.avatar}>
                          <React.Fragment>
                            <button
                              type="button"
                              className={s.btn__Upload}
                              onClick={() => setIsModalVisible(true)}
                            >
                              <img
                                src={EditButton}
                              />
                            </button>

                            <img
                              src={selectedAvatar || Avatar}
                              alt="avatar"
                              onClick={() => setIsModalVisible(true)}
                            />
                          </React.Fragment>
                          {/* <ImageUploading
                            multiple={false}
                            value={images}
                            onChange={onChange}
                            maxNumber={maxNumber}
                            dataURLKey="data_url"
                          >
                            {({
                              imageList,
                              onImageUpload,
                              onImageRemoveAll,
                              onImageUpdate,
                              onImageRemove,
                              isDragging,
                              dragProps,
                            }) => (
                              <React.Fragment>
                                <button
                                  type="button"
                                  className={s.btn__Upload}
                                  style={isDragging ? { color: "red" } : undefined}
                                  onClick={() => {
                                    imageList[0]?.data_url
                                      ? onImageUpdate(0)
                                      : onImageUpload();
                                  }}
                                  {...dragProps}
                                >
                                  <FormOutlined
                                    style={{
                                      fontWeight: "600 !important",
                                      color: "var(--first-color)",
                                      fontSize: "15px",
                                    }}
                                  />
                                </button>

                                <img
                                  src={imageList[0]?.data_url || Avatar}
                                  alt=""
                                />
                              </React.Fragment>
                            )}
                          </ImageUploading> */}
                        </div>
                      </Form.Item>
                    </Row>

                    <div className={style.form__container}>
                      <Row gutter={10}>
                        <Col span={12}>
                          <Form.Item
                            name="firstname"
                            rules={[{ required: true }]}
                            style={{ marginBottom: "20px" }}
                          >
                            <Input
                              className={`${style.field} customInput`}
                              placeholder={t("auth.firstname")}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            name="lastname"
                            rules={[{ required: true }]}
                            style={{ marginBottom: "20px" }}
                          >
                            <Input
                              className={`${style.field} customInput`}
                              placeholder={t("auth.lastname")}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Form.Item
                        name="email"
                        rules={[{ required: true }, { type: "email" }]}
                        style={{ marginBottom: "20px" }}
                      >
                        <Input
                          className={`${style.field} customInput`}
                          type="email"
                          placeholder={t("auth.email")}
                          readOnly={studentEmail !== undefined}
                          onChange={(e) => setUserEmail(e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item
                        hasFeedback
                        label={null}
                        name="phone"
                        rules={[{ required: true }]}
                        style={{ marginBottom: "20px", fontSize: "16px" }}
                      >
                        <PhoneInput
                          inputProps={{
                            name: "phone",
                            required: true,
                            autoFocus: true,
                            className: `ant-input ant-input-lg ${style.field}`,
                            style: {
                              paddingLeft: "50px",
                            },
                          }}
                          onChange={handlePhoneChange}
                          placeholder={"Numéro de téléphone (optionnel)"}
                          enableSearch
                          specialLabel=""
                          country="fr"
                          localization={fr}
                          masks={{ ci: ".. .. .. .. .." }}
                          disableCountryGuess
                          countryCodeEditable={false}
                        />
                      </Form.Item>
                      <Form.Item
                        name="password"
                        rules={[
                          { required: true },
                          {
                            pattern: /^.{6,}$/,
                            message:
                              "Le mot de passe doit contenir au moins 6 caractères !",
                          },
                        ]}
                        style={{ marginBottom: "20px" }}
                      >
                        <Input.Password
                          className={`${style.field} customInput`}
                          placeholder={t("auth.password")}
                        />
                      </Form.Item>
                      <Form.Item
                        name="confirmPassword"
                        rules={[
                          { required: true },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (!value || getFieldValue("password") === value) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                new Error("Les mots de passe ne correspondent pas :(")
                              );
                            },
                          }),
                        ]}
                        style={{ marginBottom: "20px" }}
                      >
                        <Input.Password
                          className={`${style.field} customInput`}
                          placeholder={t("auth.confirmPassword")}
                        />
                      </Form.Item>

                      <div style={{ marginTop: "20px" }}>
                        <TimeZoneList />
                      </div>

                      <Form.Item
                        name="referredBy"
                        rules={[
                          { required: false },
                        ]}
                        style={{ marginBottom: "20px" }}
                      >
                        <Input
                          type="text"
                          className={`${style.field} customInput`}
                          placeholder={"Code de parrainage (optionnel)"}
                          value={sponsorCode}
                          onChange={(e) => setSponsorCode(e.target.value)}
                          onBlur={() => checkSponsorCode(sponsorCode)}
                          maxLength={6}
                          suffix={sponsorCode.length === 6 && sponsorCodeChecked && <img src={validSponsorCode ? Check : Close} height={20}></img>}
                        />
                      </Form.Item>

                      <div className={style.termes__legals}>
                        <Form.Item
                          name="acceptedTermsAndConditions"
                          valuePropName="checked"
                          style={{ marginBottom: "20px" }}
                        >
                          <Checkbox className={style.policy}>
                            {" "}
                            J'accepte de recevoir des conseils pédagogiques et des
                            offres <br /> promotionnelles de Mon Ami Albert par
                            e-mail.{" "}
                          </Checkbox>
                        </Form.Item>
                      </div>

                      <div className={style.termes__legals}>
                        <Form.Item
                          name="acceptedMessagesAndNotifications"
                          valuePropName="checked"
                          style={{ marginBottom: "20px" }}
                        >
                          <Checkbox className={style.policy}>
                            {" "}
                            J'accepte de recevoir les notifications sur WhatsApp.{" "}
                          </Checkbox>
                        </Form.Item>
                      </div>

                      <AppButton
                        loading={auth.isRegistering || isLoadingCode || loading}
                        className={style.button}
                        htmlTypeSubmit={true}
                      >
                        Suivant
                      </AppButton>

                      <div className={style.info}>
                        <span>
                          En cliquant sur suivant, tu acceptes les <a href="/assets/files/conditions-generales.pdf" target="_blank" rel="noopener noreferrer">conditions
                            générales</a> d'utilisation et la <a href="/assets/files/politique-confidentialite.pdf" target="_blank" rel="noopener noreferrer">politique de
                              confidentialité</a> de Mon Ami Albert.
                        </span>
                      </div>
                      <div className={style.info}>
                        <p>
                          Tu as déjà un compte ?{" "}
                          <Link to={appRoutes.LOGINS}> Connecte-toi</Link>{" "}
                        </p>
                      </div>

                      {!isLoggedIn && auth.registerErrors.length > 0 &&
                        auth.registerErrors.map((error, index) => (
                          <Alert
                            key={index}
                            message={error}
                            type="error"
                            showIcon
                          />
                        ))}

                      {errorEmail && <Alert message={"Cette adresse email est déjà utilisée"} type="error" showIcon />}
                    </div>

                    {/* <RegisterTeacherForm /> */}
                  </Container>
                </div>
                <div id="recaptcha-container"></div>
              </div>
            )}

            {currentStep === 2 && (
              <Container>
                <div className={s.header}>
                  <H1>Crée ton compte</H1>
                  <div className={style.content__action}>
                    <div className={style.student__action}>
                      <div className={style.avatar}>
                        <Image
                          preview={false}
                          src={selectedAvatar || Avatar}
                          alt="student avatar"
                        />
                      </div>
                      {/* <div className={style.text}>
                      <p>
                        Hello <strong>{firstStepData?.pseudo}</strong>
                        <br />
                        Niveau <strong>{tempLevelSelected?.title}</strong>
                        <br />
                        <Link to={"#"} onClick={() => setCurrentStep(1)}>
                          Modifier
                        </Link>
                      </p>
                    </div> */}
                    </div>
                  </div>
                </div>

                <div className={s.form__content}>
                  <h3>Choisis ton pseudo</h3>
                  <div className={s.__input_choice_pseudo}>
                    <Form.Item
                      name="pseudo"
                      style={{ margin: 0, padding: 0 }}
                      rules={[
                        { required: true },
                        { max: 12, message: "12 caractère maximum" },
                      ]}
                    >
                      <Input
                        placeholder="Pseudo"
                        bordered={false}
                        defaultValue={firstStepData?.pseudo}
                      />
                    </Form.Item>
                  </div>

                  <h3>Pays de Résidence</h3>
                  <div className={s.__input_choice_pseudo}>
                    <Form.Item
                      style={{ margin: "0px" }}
                      name="pays"
                      rules={[{ required: true }]}
                    >
                      <Select
                        showSearch
                        style={{ padding: "0px", fontSize: "16px", color: "#333", textTransform: "none" }}
                        className={s.selectInput}
                        placeholder={<div style={{ fontSize: "16px", color: "#C0C0C0", textTransform: "none" }}>Choisis ton pays</div>}
                        bordered={false}
                        allowClear
                        dropdownStyle={{ padding: "3px" }}
                        showArrow={true}
                        value={country}
                        onSelect={handleCountryChange}
                        onChange={(value: string) => setCountry(value)}
                        optionFilterProp="children"
                        filterOption={(input: any, option: any) =>
                          option?.children && option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {countriesList.map((item: any, i: any) => (<Select.Option key={i} value={item}>{item}</Select.Option>))}
                      </Select>
                    </Form.Item>
                  </div>

                  <h3>Système d’éducation</h3>
                  <div className={s.__input_choice_system}>
                    <Form.Item
                      style={{ margin: "0px" }}
                      name="educSystem"
                      rules={[{ required: true }]}
                    >
                      <Select
                        style={{ padding: "0px", fontSize: "16px", color: "#333", textTransform: "none" }}
                        className={s.selectInput}
                        placeholder={<div style={{ fontSize: "16px", color: "#C0C0C0", textTransform: "none" }}>Choisis ton système</div>}
                        bordered={false}
                        allowClear
                        dropdownStyle={{ padding: "3px" }}
                        showArrow={true}
                        value={system}
                        loading={loadingSystems}
                        optionFilterProp="children"
                        onSelect={handleSystemChange}
                        onChange={(value: string) => setSystem(value)}
                      >
                        {!loadingSystems && educationSystemList.map((item: any, i: any) => (<Select.Option key={i} value={item}>{item}</Select.Option>))}
                      </Select>
                    </Form.Item>
                  </div>

                  <h3>En quelle classe es-tu ?</h3>
                  <div className={s.form}>
                    {isLoading ? (
                      <div>
                        <Skeleton active />
                        <Skeleton active />
                      </div>
                    ) : (
                      <Form.Item name="levelId" rules={[{ required: true, message: "Choisis ton niveau d'étude" }]}>
                        <Radio.Group
                          className={s.radio__group}
                          onChange={(id: any) => getLevelById(id?.target?.value)}
                        >
                          {Object.keys(allLevels || {}).map((levelGroup) => (
                            <div key={levelGroup}>
                              {/* Header Clickable Section */}
                              <div
                                onClick={() => toggleSection(levelGroup)}
                                style={{ cursor: "pointer", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", textAlign: "center" }}
                              >
                                <H2 className={s.title__level}>{levelGroup}</H2>
                                <img
                                  src={openSections[levelGroup] ? arrowUp : arrowDown}
                                  style={{
                                    position: "relative",
                                    top: "-2px",
                                    left: "5px",
                                    height: "20px",
                                  }}
                                />
                              </div>

                              {/* Levels List */}
                              <Row justify="center">
                                {allLevels[levelGroup]?.map((level: any, i: number) => (
                                  <div
                                    key={i}
                                    style={{ display: openSections[levelGroup] ? "block" : "none" }}
                                  >
                                    <Radio.Button className={s.fieldLevel} value={level._id}>
                                      {level.title}
                                    </Radio.Button>
                                  </div>
                                ))}
                              </Row>
                            </div>
                          ))}
                        </Radio.Group>
                      </Form.Item>
                    )}
                  </div>

                  <h3>Établissement Scolaire</h3>
                  <div className={s.__input_choice_school}>
                    <Form.Item
                      style={{ margin: "0px" }}
                      name="etablissement"
                      rules={[{ required: true }]}
                    >
                      <Select
                        showSearch
                        onSearch={(value) => setSearchText(value)}
                        style={{ padding: "0px", fontSize: "16px", color: "#333", textTransform: "none" }}
                        className={s.selectInput}
                        placeholder={<div style={{ fontSize: "16px", color: "#C0C0C0", textTransform: "none" }}>Choisis ton établissement</div>}
                        bordered={false}
                        allowClear
                        dropdownStyle={{ padding: "3px" }}
                        showArrow={true}
                        loading={loadingSchools}
                        optionFilterProp="children"
                        filterOption={false}
                        onChange={(value: string) => setSelectedSchool(value)}
                        onClear={() => setSelectedSchool("")}
                      >
                        {!loadingSchools &&
                          filteredSchools.map((item: string, i: number) => (
                            <Select.Option key={i} value={item}>
                              {item}
                            </Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </div>

                  {selectedSchool && selectedSchool !== "" && selectedSchool === "Autre établissement" && <div className={s.inputSchool}>
                    <Form.Item
                      name="school"
                      rules={[
                        { required: true },
                      ]}
                      style={{ marginBottom: "20px" }}
                    >
                      <Input
                        type="text"
                        bordered={false}
                        placeholder={"Entre le nom de ton établissement"}
                        value={studentSchool}
                        onChange={(e) => setStudentSchool(e.target.value)}
                      />
                    </Form.Item>
                  </div>}

                  <Row justify="center">
                    <Form.Item style={{ margin: 0 }}>
                      <AppButton className={`${s.button}`} htmlTypeSubmit={true} loading={loading}>
                        Terminer
                      </AppButton>
                    </Form.Item>
                  </Row>

                  <div className={style.info}>
                    <p>
                      Tu as déjà un compte ?{" "}
                      <Link to={appRoutes.LOGINS}> Connecte-toi</Link>{" "}
                    </p>
                  </div>
                </div>
              </Container>
            )}
          </Form>
          {/* {currentStep === 2 && <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", margin: "0px auto", textAlign: "center" }}>
            <div className={style.avatarOtp}>
              <Image
                preview={false}
                src={images[0]?.data_url || studentIcon}
                alt="student avatar"
              />
            </div>
            <H2>Code de Vérification</H2>
            <OTPForm onSubmitOtp={handleOtpSubmit} setStep={setCurrentStep} />
          </div>} */}
        </div>
      </AnimatedPage>
      <PhoneOTPModal
        visible={openPhoneVerification}
        phone={userPhoneNumber}
        onCancel={() => setOpenPhoneVerification(false)}
        onVerify={handleVerify}
        onResend={sendOtp}
        isLoading={loading}
      />
      <EmailOTPModal
        visible={openEmailVerification}
        email={userEmail}
        onCancel={() => setOpenEmailVerification(false)}
        onSubmitOtp={handleOtpSubmit}
        isLoading={loading}
      />
      <AvatarModal
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onSelect={(avatar) => {
          setSelectedAvatar(avatar);
          setIsModalVisible(false);
        }}
      />
    </>
  );
};

type Props = {
  file: any;
};

const ImagePreview: FC<Props> = ({ file }) => {
  const [preview, setPreview] = useState<any>(null);

  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => {
    setPreview(reader.result);
  };

  return preview ? <img src={preview} /> : <p>loading...</p>;
};

export default RegisterStudent;
